import { makeStyles } from "@cirrus/ui-kit";
import {DefaultColors} from "@cirrus/legacy/app-components/app/styles/colors/colors-default";

export const useStyles = makeStyles({
  headerIcon: {
    position: "absolute",
    top: "20px",
    color: DefaultColors.white,
    fontSize: "16px",

    "&:hover": {
      cursor: "pointer",
    },
  },
  minimizeIcon: {
    right: "80px",
  },
  expandIcon: {
    right: "55px",
  },
})

